import { DiContainerInjectFn } from '@@/di/ts';
import { BuyersService } from './services/buyers.service';
import { OffersService } from './services/offers.service';

export default ((container) => {
  container.bind(BuyersService).to(BuyersService).inSingletonScope();
  container.bind(OffersService).to(OffersService).inSingletonScope();
}) as DiContainerInjectFn;
